/** returns channels list
@return { Array }
*/
export const getChannelsList = state => {
    return state.channelsList
}
